import React, { useEffect, useState } from "react";
import { addUserPlans, getPlanData } from "../actions/user";
import { getAccount } from "../Hooks/useAccount";
import toast from "react-hot-toast";
import {
  ApproveToken,
  BuyPlan,
  getOwnerAccount,
  userPlanDetail,
} from "../Hooks/UseContract";
import { CHAINS, ZERO_ADDRESS } from "../Config/env";
import { CURRENT_CHAIN_ID } from "../Hooks/useWeb3";
const PlansCard = (props) => {

  const user = getAccount();
  const userData = sessionStorage.getItem("user");
  const [userPlanDetails, setUserPlanDetails] = useState();
  // const [refferAddress, setRefferAddress] = useState(userData?.referrerAddress);
  const [owner, setOwner] = useState();

  const [planExpiry, setplanExpiry] = useState();
  const [userPlanExpiry, setuserPlanExpiry] = useState();

  const [networkName, setnetworkName] = useState();


  const purchasePlan = async () => {
    try {
      console.log("PLAN PLAN");
      if (planExpiry > Date.now()) {
        toast.error("A plan Actived Already");
      }
      if (userPlanExpiry > Date.now()) {
        toast.error(
          "A plan Actived Already in " + networkName + "" + "Network"
        );
      }
      else {
        console.log(props.data.fee * 10 * 6, "props.data.fee * 10 * 18");
        let tokenApprove = await ApproveToken(props.data.fee * 10 ** 6); // poly USDT Decimal 6
        if (tokenApprove) {
          let referrer = localStorage.getItem("referrerFeeAccount")
          // let referrer = refferAddress != "" ? refferAddress : owner;
          // console.log("🚀  purchasePlan  referrer:", referrer);
          let Purchaseres = await BuyPlan({
            subId: props.data.planId,
            referrer: referrer,
          });

          if (Purchaseres) {
            setplanExpiry("");
            setUserPlanDetails({});
            let { status, message, result } = await addUserPlans({
              transactionHash: Purchaseres?.transactionHash,
              walletAddress: user.toLowerCase(),
              towalletAddress: referrer.toLowerCase(),
              planId: props.data?._id,
              chainId: CURRENT_CHAIN_ID(),
            });
            if (status == "success") {
              toast.success(message);
              detail();
              window.location.reload();
            }
          }
        }
        else {
          toast.error("Something Went Wrong");
        }
      }
    } catch (err) {
      console.log(err, "ERR");
    }
  };

  const userPlan = async (userId) => {
    try {
      let { status, message, data } = await getPlanData({
        userId: userId,
      });
      if (status == true) {
        setuserPlanExpiry(Number(data.expiryTime) * 1000);
        setplanExpiry(Number(data.expiryTime) * 1000);
        let chainName = CHAINS.find((value) => value.CHAIN_ID == data.chainId);
        setnetworkName(chainName.NAME);
      }
      console.log(status, message, data, "status, message, data");
    } catch (err) {
      console.log(err);
    }
  };

  const detail = async () => {
    let owner = await getOwnerAccount();
    console.log("🚀  detail  owner:", owner);
    setOwner(owner);
    let userP = await userPlanDetail();
    console.log("🚀  detail  userP:", userP);
    setUserPlanDetails(userP);
    setplanExpiry(new Date(Number(userP?.validTill) * 1000).getTime());
  };

  useEffect(
    () => {
      console.log("props.data?", props.data)

      detail();
      let userData = sessionStorage.getItem("user");
      console.log("🚀 ~ PlansCard ~ userData:", userData);
      userData = JSON.parse(userData);
      userPlan(userData?._id);
      // setRefferAddress(userData?.referrerAddress);
    },
    user,
    []
  );

  return (
    <>
      <div
        className={
          planExpiry < Date.now()
            ? "plansCard px-4 py-4"
            : "active plansCard px-4 py-4"
        }
      >
        <div className="plansCard__top">
          <div className="plansCard__topinner">
            <div className="w-100">
              <h6
                className={
                  planExpiry < Date.now()
                    ? "m-0 hebrew_bold plansCard__status d-flex align-items-center justify-content-between"
                    : "active m-0 hebrew_bold plansCard__status d-flex align-items-center justify-content-between"
                }
              >
                {props.data.name}
                <img
                  src={require("../Assets/Images/plancard_dots.png")}
                  className="img-fluid dots_src"
                />
              </h6>

              <h4 className="m-0 hebrew_bold plansCard__price mt-3">
                {props.data.fee} - USDT
              </h4>

              <p className="m-0 hebrew_font plansCard__hint mt-3">
                Duration : {props.data?.duration} Days
              </p>

              <p className="m-0 hebrew_font plansCard__hint mt-2">
                Trades Per Day : {props.data.tradesPerDay}
              </p>

              {props.data.minProfitPerStatus == true ? (
                <p className="m-0 hebrew_font plansCard__hint mt-2">
                  Up to : {props.data.minProfitPer}% Daily Profit
                </p>
              ) : (
                ""
              )}
            </div>

            {/* {userPlanDetails &&
            props.data.planId == userPlanDetails?.subscribeId ? (
            <h6
              className={
                planExpiry < Date.now()
                  ? "mb-0 plan-status expiry"
                  : "mb-0 plan-status active"
              }
            >
              {planExpiry < Date.now() ? "Expiry" : "Active"}
            </h6>
          ) : (
            ""
          )} */}
          </div>

          <p className="m-0 hebrew_font plansCard__hint mt-2">
            Max Profit : {props.data.maxProfitPer}%{" "}
          </p>
          <p className="m-0 hebrew_font plansCard__hint mt-2">
            Total Flashloan Granted : {props.data.flashLoanAmount}
          </p>
          <p className="m-0 hebrew_font plansCard__hint mt-2">Highlights :</p>

          {props.data && props.data.highlights.length > 0
            ? props.data.highlights.map((highlightItem) => {
              {
              }
              return (
                <p className="m-0 hebrew_font plansCard__hint mt-2">
                  {highlightItem}
                </p>
              );
            })
            : ""}

          {console.log("planExpiry", planExpiry)}
        </div>


        {props.data && props.data.planStatus == true ? (
          props.data.planId == userPlanDetails?.subscribeId ? (
            planExpiry > Date.now() ? (
              <button
                className="btn btn-primary planCard_btn mt-3 planCard_btn"
                disabled
              >
                Active
              </button>
            ) : (
              <button
                className="btn btn-primary planCard_btn active mt-3"
                data="Active"
                disabled
              >
                Active
              </button>
            )
          ) : (
            <button
              className="btn btn-primary planCard_btn mt-3"
              onClick={() => purchasePlan()}
            >
              Buy Plan
            </button>
          )
        ) : (
          <button className="btn btn-primary planCard_btnSold_out mt-3" disabled>
            Sold Out!
          </button>
        )}


        {/* <button
          className="planCard_btn mt-3"
          // data="Active"
          onClick={() => purchasePlan()}
        >
          Buy Plan
        </button> */}


      </div>
    </>
  );
};

export default PlansCard;
